import { Box, Image, SpacerNew, Text, useWindowDimensions } from '@jfs/ui-new'
import { useState } from 'react'
import { staticStrings } from '../../static/staticStrings'
import usePadding from '../../util/usePadding'
import { isMobileWidth } from '../../util/util'

export const SafetyAndSecurity = () => {
  const resPadding = usePadding()
  const [height, setHeight] = useState(0)
  const viewportWidth = useWindowDimensions()
  const isMob = isMobileWidth(viewportWidth)
  return (
    <Box align={'center'} mt={isMob ? 120 : 108}>
      <Image source={require('../../assets/images/safety-bg.png')} width={'100%'} height={height - 4} />
      <Box
        ph={resPadding}
        pv={isMob ? 64 : 16}
        position={'absolute'}
        top={0}
        align={'center'}
        justify={'space-between'}
        flexDirection={isMob ? 'column-reverse' : 'row'}
        onLayout={(evt: any) => setHeight(evt?.nativeEvent?.layout?.height)}>
        <Box
          f={isMob ? undefined : 0.5}
          align={isMob ? 'center' : 'flex-start'}
          ph={isMob ? resPadding : undefined}
          pv={isMob ? 64 : 0}>
          <Text
            title={staticStrings.safetyAndSecurity}
            fontFamily={'jiotype-black'}
            fontSize={isMob ? 24 : 64}
            lineHeight={isMob ? 36 : 80}
            letterSpacing={isMob ? 0 : -2.5}
            color={'WHITE'}
            textAlign={isMob ? 'center' : 'left'}
          />
          <SpacerNew size={24} />
          <Box marginRight={isMob ? 0 : '16%'}>
            <Text
              title={staticStrings.safetyAndSecuritySubTitle}
              fontFamily={isMob ? 'jiotype-medium' : 'jiotype-light'}
              fontSize={isMob ? 14 : 24}
              lineHeight={isMob ? 20 : 40}
              letterSpacing={isMob ? 0 : -0.48}
              color={'WHITE'}
              opacity={isMob ? 0.7 : 1}
              textAlign={isMob ? 'center' : 'left'}
            />
          </Box>
        </Box>
        <Box f={isMob ? undefined : 0.5} align={isMob ? 'center' : 'flex-end'}>
          <Image
            source={require('../../assets/images/safe-secure.png')}
            width={isMob ? 240 : '100%'}
            height={isMob ? 240 : 660}
            resizeMode={'center'}
          />
        </Box>
      </Box>
    </Box>
  )
}
